import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <div>
      <ng-container>
        <i class="fa fa-user-plus" nbTooltip="{{ data.tooltip }}" nbTooltipStatus="basic" nbTooltipPlacement="bottom" (click)="action()"></i>
      </ng-container>
    </div>
    `,
  styleUrls: ['./add-child-cell.component.scss'],
})
export class AddChildCellComponent {
  @Input() data: any;

  action() {
    event.preventDefault();
    event.stopPropagation();
    this.data.action(this.data.id, false);
  }
}
